<template>
  <div class="posts-page">
    <h1>This is the posts page</h1>
  </div>
</template>

<script>
export default {
  name: 'Posts'
}
</script>

<style scoped>
</style>
